import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { BrandComparisonDSWidget } from './brand-comparison-ds-widget'
import { BrandComparisonWidgetLegacy } from './brand-comparison-widget-legacy'

import type { BrandComparisonWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

/**
 * BRAND_COMPARISON widget — the PDP "Beyond compare" price/feature table on the PL path.
 *
 * Renders the DS 2.0 `BrandComparisonDSWidget` when the design system is enabled
 * (`shouldUseDesignSystem()`), otherwise the legacy `BrandComparisonWidgetLegacy`. Both build the
 * competitor tables from the widget's own data and read the live Quince price + resolved variant +
 * gift-card/servings scalars from the PRODUCT_PURCHASE buy box via the shared page-widget store. The
 * error boundary isolates any runtime issue so it can never disturb the rest of the PDP.
 */
const BrandComparisonWidgetComponent = (props: PLTypedWidgetProps<BrandComparisonWidgetData>) => {
  if (shouldUseDesignSystem()) {
    return <BrandComparisonDSWidget {...props} />
  }
  return <BrandComparisonWidgetLegacy {...props} />
}

export const BrandComparisonWidget: PLTypedWidgetInterface<BrandComparisonWidgetData, WidgetType.BRAND_COMPARISON> = {
  id: WidgetType.BRAND_COMPARISON,
  errorBoundary: PLBaseErrorBoundary,
  render: BrandComparisonWidgetComponent,
}
